<template>
    <div class="timers-container">
        <TimerGroupModalCard
            v-for="timer in groupTimers"
            :key="timer.id"
            :timer="timer"
            :now="now"
            :selected="isSelected(timer)"
            :disabled="isDeleting"
            :product-image="getProductImage(timer)"
            :product-name="getProductName(timer)"
            @select="$emit('select', timer)"
            @longpress="$emit('longpress', timer)"
        />

        <div v-if="groupTimers.length === 0" class="empty-group">
            <span>{{ $t('timersproduct.group.no_timers') }}</span>
        </div>
    </div>
</template>

<script>
import TimerGroupModalCard from '@/components/domain/timerproduct/TimerGroupModalCard.vue'

export default {
    name: 'TimerGroupModalCardsList',
    components: { TimerGroupModalCard },
    props: {
        groupTimers: {
            type: Array,
            required: true,
            default: () => []
        },
        isDeleting: {
            type: Boolean,
            default: false
        },
        selectedTimerIds: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            now: moment(),
            intervalId: null
        }
    },
    created() {
        this.intervalId = setInterval(() => {
            this.now = moment()
        }, 1000)
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }
    },
    methods: {
        isSelected(timer) {
            return this.selectedTimerIds.includes(timer.id)
        },
        getProductImage(timer) {
            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)
            return product ? product.image : ''
        },
        getProductName(timer) {
            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)
            return product ? product.name : timer.data.product || ''
        }
    }
}
</script>

<style lang="scss" scoped>
.timers-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 16px;
    gap: 16px;
    @include flex-grow(1);
    @include flex-shrink(0);
    @include flex-basis(0);
    border-radius: 4px;
    border: 1px solid $color-neutral-300;
    background: $color-neutral-100;
    overflow-y: scroll;
    align-content: start;
}

.empty-group {
    @include display-flex();
    @include justify-content(center);
    @include align-items(center);
    padding: 40px;
    color: $color-neutral-600;
    font-size: 14px;
    grid-column: 1 / -1;
}
</style>
